import $ from 'jquery';

function resetDropdowns() {

	$('.header_nav .-parent > ul').removeClass('is-open');
	
	$('.header_nav .-parent > ul').addClass('is-closed');

	$('.header-menu-open-bg').remove();
}

function openDropdown(el) {
	el.removeClass('is-closed');
	el.addClass('is-open');

	$('body').append('<div class="header-menu-open-bg"></div>');
}

function headerClickOpen() {

	var $links = $('.header_nav .-parent > a');

	resetDropdowns();

	$links.click(function (e){
		e.preventDefault();

		if($(this).next().hasClass('is-open')){
			// window.location.href = $(this).attr('href');
			resetDropdowns();
			// console.log('href: ', $(this).attr('href'));
		} else {
			resetDropdowns();
			openDropdown($(this).next());
		}
	});


	$(document).click(function(event){
		// var _this = $(this);
		// console.log(_this);
		// console.log("target: ", event.target);
		if(!$(event.target).closest('.-parent').length){
			if($('.header_nav .-parent > ul .is-open')){
				resetDropdowns();
			}
		}
	});

	// console.log($parents);

}

export default function headerSection() {
	const $html = $('html');
	const $scroller = $('html, body');

	const $header = $('#header');
	const $headerNav = $('#header-nav');
	const headerToggler = $headerNav.data('toggler');

	if (headerToggler) {

		headerToggler.on('toggle', function() {
			$html.toggleClass('is-header-open', headerToggler.isOpen);

			if (headerToggler.isOpen) {
				$scroller.animate({ scrollTop: 0 }, { duration: 200 });
			}
		});
	}

	headerClickOpen();

}



// WEBPACK FOOTER //
// ./source/scripts/sections/header.js